import React from "react";
import { Id, IToolbarElement, Toolbar, Toolbar as DhxToolbar } from "dhx-suite";

interface ToolbarViewProps {
    controls: IToolbarElement[];
    className?: string;
    onClick?: (id: Id, e: MouseEvent) => void;
    onChange?: (id: Id, value: any) => void;
    onToolbarMounted?: (toolbar: Toolbar, ref: React.Ref<HTMLDivElement>) => void;
}

export const StaticToolbar = ({ controls: data, className, onChange, onClick, onToolbarMounted }: ToolbarViewProps) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [toolbar, setToolbar] = React.useState<Toolbar>();

    React.useEffect(() => {
        if (ref.current) {
            data.forEach(i => delete i.parent)
            const toolbar = new DhxToolbar(ref.current, { data });
            setToolbar(toolbar);
            if (onToolbarMounted) {
                onToolbarMounted(toolbar, ref);
            }
        }
    }, []);
    React.useEffect(() => {
        if (toolbar) {
            if (onChange) {
                toolbar.events.on("change", ({ id, type, value }) => {
                    if (type === "input") {
                        onChange(id, value);
                    }
                });
            }

            if (onClick) {
                toolbar.events.on("click", onClick);
            }

            return () => {
                if (onChange) {
                    toolbar.events.detach("change");
                }
                if (onClick) {
                    toolbar.events.detach("click");
                }
            };
        }
        return undefined;
    });

    return <div className={className} ref={ref} />;
};
